import Model from './Model'
import Report from './Report'

export default class Comment extends Model {
  resource() {
    return 'comments'
  }

  reports() {
    return this.hasMany(Report)
  }
}
